module.exports = __webpack_public_path__ + "img/md-person-add.12ba58a7.svg";